import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useApp} from '../../../contexts/AppContext';
import {getEventDetail} from '../../../api';
import {useCustomDialog} from '../../../contexts/CustomDialogContext';

import styled from 'styled-components';
import config from '../../../config';
import {Link, useLocation} from 'react-router-dom';
import {PageFeatureTitle} from '../PlaylistsPage';
import moment from 'moment';
import {useAuth} from '../../../contexts/UserContext';

const Page = styled.div`
  padding-top: 43px;
  @media ${config.layout.wide} {
    padding-top: 75px;
  }
`;

const BackToListArea = styled.div`
  text-align: right;
  position: sticky;
  display: flex;
  top: 75px;
  @media ${config.layout.wide} {
    top: 100px;
  }

  &::before {
    content: "";
    display: block;
    width: 100%;
    pointer-events: none;
  }
`;

const BackToListLinkWrap = styled.div`
  flex: 0 0 auto;
  position: relative;

  .back-to-list-button {
    display: inline;
    text-decoration: none;
    height: 46px;
    line-height: 46px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    padding: 0 20px;

    span {
      z-index: 1;
      position: relative;
      color: #fff;
    }

    &:hover {
      &::before {
        opacity: 0.7;
      }
    }

    &::before {
      border-radius: 0px 0px 4px 4px;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg,
      rgba(98, 98, 98, 1) 0%,
      rgba(0, 0, 0, 1) 100%);
      opacity: 1;
      transition: opacity 0.15s linear;
      z-index: 0;
    }
  }
`;

const EventDataArea = styled.div`
  margin-top: -19px;

  h4 {
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
  }

  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 40px;
`;

const EventDataDate = styled.div`
  margin-top: 10px;
  font-size: 26px;
  font-weight: bold;
  line-height: 34px;
`;

const EventDataFloor = styled.div`
  margin-top: 0px;
  font-size: 26px;
  font-weight: bold;
  line-height: 34px;
  overflow-wrap: break-word;
`;

const EventDetailArea = styled.div`
  @media ${config.layout.wide} {
    display: flex;
    gap: 20px;
  }
`;

const EventDetailInfoBlock = styled.div`
  @media ${config.layout.wide} {
    width: calc(50% - 10px);
    flex: 0 0 auto;
  }
`;

const EventDetailInfoItem = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
`;

const EventDetailInfoItemKey = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  overflow-wrap: break-word;
  width: 120px;
  flex: 0 0 auto;
`;

const EventDetailInfoItemValue = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  overflow-wrap: break-word;
  flex: 1 0 auto;
  width: calc(100% - 120px);
`;

const EventDetailDeviceBlock = styled.div`
  height: 140px;
  @media ${config.layout.wide} {
    width: calc(50% - 10px);
    flex: 0 0 auto;
    height: 180px;
  }

  border-bottom: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  gap: 20px;
`;

const EventDetailDeviceImage = styled.div`
  width: 94px;
  height: 130px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

const EventDetailDeviceInfo = styled.div`
  width: calc(100% - 95px - 20px);
`;

const EventDetailDeviceInfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 9px;

  &:first-child {
    margin-top: 0;
  }
`;

const EventDetailDeviceInfoItemKey = styled.div`
  width: 114px;
  font-size: 14px;
  font-weight: bold;
`;

const EventDetailDeviceInfoItemValue = styled.div`
  font-size: 12px;
  font-weight: 500;
`;

const PlaylistArea = styled.div`
  margin-top: 40px;
  @media ${config.layout.wide} {
    margin-top: 50px;
  }

  h4 {
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d9d9d9;
  }
`;

const PlaylistTracks = styled.div``;

const PlaylistTrackItem = styled.div`
  padding: 20px 0 30px 0;
  border-bottom: 1px solid #d9d9d9;

`;

const PlaylistTrackItemTitle = styled.div`
  overflow-wrap: break-word;
  font-size: 20px;
  line-height: 26px;
  font-weight: bold;
`;

const PlaylistTrackItemArtist = styled.div`
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  margin-top: 10px;
`;

const PlaylistTrackItemDate = styled.div`
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  margin-top: 10px;
`;

const NoTrackMessage = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 60px;
  margin-bottom: 30px;
`;

export default function PlaylistDetailPage() {
  const {event_id} = useParams();
  const auth = useAuth();
  const {errorDialogWithAPIError} = useCustomDialog();
  const app = useApp();
  const location = useLocation();
  const [data, setData] = useState({
    event: null,
    tracks: [],
    device: null,
  });

  let listQuery = new URLSearchParams(
      (location.state && location.state.query) || {},
  ).toString();

  useEffect(() => {
    app.showHeader();
    document.title = 'Playlists';
  }, []);

  useEffect(() => {
    let detached = false;
    (async (event_id) => {
      if (detached) {
        return;
      }
      try {
        window.incrementLoading();
        let {tracks, event, device} = await getEventDetail({
          event_id,
        });
        console.log(tracks, event, device);
        setData({
          event,
          tracks,
          device,
        });
        window.decrementLoading();
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        if (!detached) {
          await errorDialogWithAPIError(e);
          setData({
            event: null,
            tracks: [],
            device: null,
          });
        }
      }
    })(event_id);

    return () => {
      detached = true;
    };
  }, [event_id]);

  if (!data.event) {
    return '';
  }

  const tracks = (
      (data.tracks && data.tracks.length && data.tracks) ||
      []
  ).slice();
  if (data.event.event_status == 0) {
    tracks.reverse();
  }

  return (
      <Page>
        <PageFeatureTitle>
          <h2>Playlists</h2>
          <div>
          <span>
            Please don't publish playlists – they're confidential and should only be used internally at your venue.
          </span>
          </div>
        </PageFeatureTitle>
        <BackToListArea>
          <BackToListLinkWrap>
            <Link
                to={`/playlists/${listQuery ? '?' + listQuery : ''}`}
                className="back-to-list-button"
            >
              <span>Back to Index</span>
            </Link>
          </BackToListLinkWrap>
        </BackToListArea>
        <EventDataArea>
          <h4>EVENT</h4>
          <EventDataDate>
            {moment(data.event.event_local_datetime).format('YYYY/MM/DD')}
          </EventDataDate>
          <EventDataFloor>
            {auth.state.venue.name}/{data.event.floor_name}
          </EventDataFloor>
        </EventDataArea>
        <EventDetailArea>
          <EventDetailInfoBlock>
            <EventDetailInfoItem>
              <EventDetailInfoItemKey>Date</EventDetailInfoItemKey>
              <EventDetailInfoItemValue>
                {moment(data.event.event_local_datetime).format('YYYY/MM/DD')}
              </EventDetailInfoItemValue>
            </EventDetailInfoItem>
            <EventDetailInfoItem>
              <EventDetailInfoItemKey>Start time</EventDetailInfoItemKey>
              <EventDetailInfoItemValue>
                {moment(data.event.event_local_datetime).format('HH:mm:ss')}
              </EventDetailInfoItemValue>
            </EventDetailInfoItem>
            <EventDetailInfoItem>
              <EventDetailInfoItemKey>Room / floor</EventDetailInfoItemKey>
              <EventDetailInfoItemValue>
                {data.event.floor_name}
              </EventDetailInfoItemValue>
            </EventDetailInfoItem>
          </EventDetailInfoBlock>
          <EventDetailDeviceBlock>
            <EventDetailDeviceImage
                style={{
                  backgroundImage: `url(${data.device.image_url})`,
                }}
            />
            <EventDetailDeviceInfo>
              <EventDetailDeviceInfoItem>
                <EventDetailDeviceInfoItemKey>
                  Device model
                </EventDetailDeviceInfoItemKey>
                <EventDetailDeviceInfoItemValue>
                  {data.device.device_name}
                </EventDetailDeviceInfoItemValue>
              </EventDetailDeviceInfoItem>

              <EventDetailDeviceInfoItem>
                <EventDetailDeviceInfoItemKey>
                  KUVO Device ID
                </EventDetailDeviceInfoItemKey>
                <EventDetailDeviceInfoItemValue>
                  {data.device.customer_id}
                </EventDetailDeviceInfoItemValue>
              </EventDetailDeviceInfoItem>

              <EventDetailDeviceInfoItem>
                <EventDetailDeviceInfoItemKey>
                  Serial no.
                </EventDetailDeviceInfoItemKey>
                <EventDetailDeviceInfoItemValue>
                  {data.device.serial_code || '- - - - - - - - - -'}
                </EventDetailDeviceInfoItemValue>
              </EventDetailDeviceInfoItem>

              <EventDetailDeviceInfoItem>
                <EventDetailDeviceInfoItemKey>
                  Registered
                </EventDetailDeviceInfoItemKey>
                <EventDetailDeviceInfoItemValue>
                  {data.device.associate_datetime ? moment(
                      data.device.associate_datetime).format('YYYY/MM/DD') : ''}
                </EventDetailDeviceInfoItemValue>
              </EventDetailDeviceInfoItem>

            </EventDetailDeviceInfo>
          </EventDetailDeviceBlock>
        </EventDetailArea>
        <PlaylistArea>
          <h4>Playlist</h4>

          {tracks.length ? (
              <PlaylistTracks>
                {tracks.map((track, i) => {
                  return (
                      <PlaylistTrackItem key={i}>
                        <PlaylistTrackItemTitle>
                          {track.title || ''}
                        </PlaylistTrackItemTitle>
                        {track.artist ? (
                            <PlaylistTrackItemArtist>
                              {track.artist || ''}
                            </PlaylistTrackItemArtist>
                        ) : (
                            ''
                        )}

                        <PlaylistTrackItemDate>
                          {moment(track.played_local_datetime).format(
                              'YYYY/MM/DD HH:mm:ss',
                          )}
                        </PlaylistTrackItemDate>
                      </PlaylistTrackItem>
                  );
                })}
              </PlaylistTracks>
          ) : (
              <NoTrackMessage>No track loaded.</NoTrackMessage>
          )}
        </PlaylistArea>
      </Page>
  );
}
